const tabs = {
  ysts: [
    {
      name: "zxys",
      btn: "img/tab1/btn1-d.png",
      btnactive: "img/tab1/btn1-a.png",
      bgimg: "img/ysts/zxys-bg.jpg",
      ttimg: "img/ysts/zxys-tt.png"
    },
    {
      name: "byys",
      btn: "img/tab1/btn2-d.png",
      btnactive: "img/tab1/btn2-a.png",
      bgimg: "img/ysts/byys-bg.jpg",
      ttimg: "img/ysts/byys-tt.png"
    },
    {
      name: "gyts",
      btn: "img/tab1/btn3-d.png",
      btnactive: "img/tab1/btn3-a.png",
      bgimg: "img/ysts/gyts-bg.jpg",
      ttimg: "img/ysts/gyts-tt.png"
    }
  ],
  qyfz: [
    {
      name: "qiyuan",
      btn: "img/tab1/btn1-d.png",
      btnactive: "img/tab1/btn1-a.png",
      ttimg: "img/qyfz/qiyuan-tt.png"
    },
    {
      name: "fazhan",
      btn: "img/tab1/btn2-d.png",
      btnactive: "img/tab1/btn2-a.png",
      ttimg: "img/qyfz/fazhan-tt.png"
    },
    {
      name: "chuanbo",
      btn: "img/tab1/btn3-d.png",
      btnactive: "img/tab1/btn3-a.png",
      ttimg: "img/qyfz/chuanbo-tt.png"
    }
  ],
  pygn: [
    {
      name: "wsgn",
      btn: "img/tab1/btn1-d.png",
      btnactive: "img/tab1/btn1-a.png",
      ttimg: "img/pygn/wsgn-tt.png",
      bgimg: "img/pygn/wsgn-bg.jpg"
    },
    {
      name: "jhgn",
      btn: "img/tab1/btn2-d.png",
      btnactive: "img/tab1/btn2-a.png",
      ttimg: "img/pygn/jhgn-tt.png",
      bgimg: "img/pygn/jhgn-bg.jpg"
    },
    {
      name: "ylgn",
      btn: "img/tab1/btn3-d.png",
      btnactive: "img/tab1/btn3-a.png",
      ttimg: "img/pygn/ylgn-tt.png",
      bgimg: "img/pygn/ylgn-bg.jpg"
    },
    {
      name: "smgn",
      btn: "img/tab1/btn1-d.png",
      btnactive: "img/tab1/btn1-a.png",
      ttimg: "img/pygn/smgn-tt.png",
      bgimg: "img/pygn/smgn-bg.jpg"
    }
  ],
  dfts: [
    {
      name: "shanxi",
      ttimg: "img/dfts/shanxi-tt.png"
    },
    {
      name: "tangshan",
      ttimg: "img/dfts/tangshan-tt.png"
    },
    {
      name: "shanxi2",
      ttimg: "img/dfts/shanxi2-tt.png"
    },
    {
      name: "zhejiang",
      ttimg: "img/dfts/zhejiang-tt.png"
    },
    {
      name: "sichuan",
      ttimg: "img/dfts/sichuan-tt.png"
    },
    {
      name: "gansu",
      ttimg: "img/dfts/gansu-tt.png"
    },
    {
      name: "hubei",
      ttimg: "img/dfts/hubei-tt.png"
    },
    {
      name: "hunan",
      ttimg: "img/dfts/hunan-tt.png"
    },
    {
      name: "yunnan",
      ttimg: "img/dfts/yunnan-tt.png"
    },
    {
      name: "liaoning",
      ttimg: "img/dfts/liaoning-tt.png"
    },
    {
      name: "qinghai",
      ttimg: "img/dfts/qinghai-tt.png"
    },
    {
      name: "shandong",
      ttimg: "img/dfts/shandong-tt.png"
    },
    {
      name: "henan",
      ttimg: "img/dfts/henan-tt.png"
    },
    {
      name: "guangdong",
      ttimg: "img/dfts/guangdong-tt.png"
    }
  ],
  pyms: [
    {
      name: "ybxs",
      btn: "img/pyms/btn-ybxs.png",
      btnactive: "img/pyms/btn-ybxs.png",
      subtabs: ["拜师<br/>与谢师", "影戏班<br/>禁忌", "影戏班<br/>行话"],
      bgimg: "img/pyms/ybxs-bg.jpg"
    },
    {
      name: "gdms",
      btn: "img/pyms/btn-gdms.png",
      btnactive: "img/pyms/btn-gdms.png",
      subtabs: [
        "“愿影”<br/>“会影”",
        "“堂影”",
        "“喜影”<br/>“丧影”",
        "“蚕花戏”",
        "节戏"
      ],
      bgimg: "img/pyms/gdms-bg.jpg"
    }
  ],
  pyzz: [
    {
      name: "zhipi",
      swiperPics: [
        "img/pyzz/zhipi-1.jpg",
        "img/pyzz/zhipi-2.jpg",
        "img/pyzz/zhipi-3.jpg",
        "img/pyzz/zhipi-4.jpg"
      ]
    },
    {
      name: "huagao",
      swiperPics: ["img/pyzz/huagao-1.jpg", "img/pyzz/huagao-2.jpg"]
    },
    {
      name: "guogao",
      swiperPics: [
        "img/pyzz/guogao-1.jpg",
        "img/pyzz/guogao-2.jpg",
        "img/pyzz/guogao-3.jpg"
      ]
    },
    {
      name: "diaoke",
      swiperPics: [
        "img/pyzz/diaoke-1.jpg",
        "img/pyzz/diaoke-2.jpg",
        "img/pyzz/diaoke-3.jpg",
        "img/pyzz/diaoke-4.jpg"
      ]
    },
    {
      name: "fucai",
      swiperPics: [
        "img/pyzz/fucai-1.jpg",
        "img/pyzz/fucai-2.jpg",
        "img/pyzz/fucai-3.jpg",
        "img/pyzz/fucai-4.jpg"
      ]
    },
    {
      name: "fahan",
      swiperPics: [
        "img/pyzz/fahan-1.jpg",
        "img/pyzz/fahan-2.jpg",
        "img/pyzz/fahan-3.jpg"
      ]
    },
    {
      name: "zhuijie",
      swiperPics: [
        "img/pyzz/zhuijie-1.jpg",
        "img/pyzz/zhuijie-2.jpg",
        "img/pyzz/zhuijie-3.jpg"
      ]
    }
  ],
  pyby: [
    {
      name: "method",
      btn: "img/pyby/btn-byff.png",
      btnactive: "img/pyby/btn-byff.png",
      ttimg: "img/pyby/byff-tt.png",
      bgimg: "img/pyby/byff-bg.jpg",
      subtabs: [
        "搭台",
        "演出<br/>程序",
        "演员<br/>安排",
        "操作<br/>特技",
        "演唱<br/>形式",
        "剧目"
      ]
    },
    {
      name: "gramophone",
      btn: "img/pyby/btn-gramophone.png",
      btnactive: "img/pyby/btn-gramophone.png",
      ttimg: "img/pyby/gramophone-tt.png",
      bgimg: "img/pyby/pyby-bg.jpg"
    },
    {
      name: "theater",
      btn: "img/pyby/btn-theater.png",
      btnactive: "img/pyby/btn-theater.png",
      ttimg: "img/pyby/theater-tt.png",
      bgimg: "img/pyby/pyby-bg.jpg"
    },
    {
      name: "prelude",
      btn: "img/pyby/btn-prelude.png",
      btnactive: "img/pyby/btn-prelude.png",
      ttimg: "img/pyby/prelude-tt.png",
      bgimg: "img/pyby/pyby-bg.jpg"
    }
  ],
  gczp: [
    {
      name: "puppet",
      btn: "img/gczp/btn-puppet.png",
      btnactive: "img/gczp/btn-puppet.png",
      ttimg: "img/gczp/puppet-tt.png"
    },
    {
      name: "script",
      btn: "img/gczp/btn-script.png",
      btnactive: "img/gczp/btn-script.png",
      ttimg: "img/gczp/script-tt.png"
    },
    {
      name: "prop",
      btn: "img/gczp/btn-prop.png",
      btnactive: "img/gczp/btn-prop.png",
      ttimg: "img/gczp/prop-tt.png"
    }
  ],
  pyyz: [
    {
      name: "graphic",
      ttimg: "img/pyyz/graphic-tt.png"
    },
    {
      name: "animation",
      ttimg: "img/pyyz/animation-tt.png"
    },
    {
      name: "pianhua",
      ttimg: "img/pyyz/pianhua-tt.png"
    },
    {
      name: "games",
      ttimg: "img/pyyz/games-tt.png"
    },
    {
      name: "stamp",
      ttimg: "img/pyyz/stamp-tt.png"
    },
    {
      name: "ringtone",
      ttimg: "img/pyyz/ringtone-tt.png"
    },
    {
      name: "emoji",
      ttimg: "img/pyyz/emoji-tt.png"
    },
    {
      name: "documentary",
      ttimg: "img/pyyz/documentary-tt.png"
    }
  ],
  yjzx: [
    {
      name: "pywx"
    },
    {
      name: "xsbg"
    },
    {
      name: "ksls"
    },
    {
      name: "jgrw"
    },
    {
      name: "dangan"
    }
  ],
  about: [
    {
      name: "chengyuan"
    },
    {
      name: "mingxie"
    },
    {
      name: "shengming"
    },
    {
      name: "contact"
    }
  ]
};

export default tabs;
